<template>
    <keep-alive>
         <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size sm_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>{{ $t('TITLE.POPUP.SELECT.TEAM') }}</i>
                        </dt>
                        <dd>
                            <!-- Grid -->
                            <div class="grid_wrap mt10">
                                <table class="scroll_table">
                                    <colgroup>
                                        <col width="15%">
                                        <col width="35%">
                                        <col width="*">
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th class="tC" width="15%">{{ $t('FIELD.GLOVAL.CHECK')}}</th>
                                            <th class="tC" width="35%">{{ $t('FIELD.USER.TEAM.ID') }}</th>
                                            <th class="tC" width="*">{{ $t('FIELD.USER.TEAM.NAME') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text_center">
                                        <tr v-for="team in teamList" :key="team.TEAMNO">
                                            <td class="tC" width="15%">
                                                <label class="radiobox-wrap">
                                                    <input type="radio" name="selAuth" v-model="team.selected" @change="selectRowChk(team)" />
                                                    <i class="radio-icon"></i>
                                                </label>
                                            </td>
                                            <td width="35%">{{ team.TEAMNO }}</td>
                                            <td width="*">{{ team.TEAMNAME }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- detail_Authorization-->
                            <table class="create_table mt20">
                                <colgroup>
                                    <col width="35%" />
                                    <col width="*" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>{{$t('FIELD.AUTHREQ.AUTH')}}</th>
                                        <td>
                                            <label class="radiobox-wrap ">
                                                <input type="radio" name="creation" v-model="creationYn" value="N" checked="" />
                                                <i class="radio-icon"></i>
                                                <em>{{$t('FIELD.GLOBAL.ONLY.VIEW')}}</em>
                                            </label>
                                            <label class="radiobox-wrap">
                                                <input type="radio" name="creation" v-model="creationYn" value="Y" />
                                                <i class="radio-icon"></i>
                                                <em>{{$t('FIELD.GLOBAL.CREATION')}}</em>
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </dd>
                        <!-- 200707수정(버튼 하단으로 이동) S -->
                        <dd class="scroll_btm">
                            <div class="btn_modal_wrap topLine" style="padding:10px 1px 1px 1px; margin:5px 0px 1px 0px;">
                                <div class="btn_right">
                                    <a href="JavaScript:" class="btn_white" title @click="$emit('close')">{{$t('BUTTON.GLOBAL.CANCEL')}}</a>
                                    <a href="JavaScript:" class="btn_blue" title @click="btnSave()">{{$t('BUTTON.GLOBAL.SELECT')}}</a>
                                </div>
                            </div>
                        </dd>
                        <!-- 200707수정(버튼 하단으로 이동) E -->
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue              from 'vue';
import qs               from 'query-string';
import axios            from 'axios';
import { SDLUtil }      from '@/utils';
import { EventBus }     from '@/utils/EventBus';

export default {
    name: 'TeamAddPopup',
    props: {
        rtnFunc: { type: Function }
    },
    data() {
        return {
            creationYn: 'N',
            selectItem: {},
            teamList: [],
            selectList: [],
            options: {
                scrollY: false,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 318,
            }
        };
    },
    methods: {
        async onSearch() {
            const param = {};
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/common/team/teamAllSearch.skp`, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.teamList = resp.data.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        selectRowChk(item) {
            this.selectItem = item;
        },
        btnSave() {
            this.selectItem.CREATIONYN = this.creationYn;
            if (!this.selectItem.TEAMNO) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');

            } else {
                this.rtnFunc(this.selectItem);
                this.$emit('close');
            }
        }
    },
    mounted() {
        this.onSearch();
    },
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/boardManage/popup/TeamAddPopup.vue